export enum Product {
  ems = 'ems',
  erp = 'erp',
  smartstart = 'smartstart',
  wacs = 'wacs',
  ccn = 'ccn',
  upstart = 'upstart',
  ayla = 'ayla',
  assessments = 'assessments',
}

export const PRODUCT_DISPLAY_NAME = {
  [Product.ems]: 'Early Math & Science',
  [Product.erp]: 'Early Reading',
  [Product.smartstart]: 'SmartStart',
  [Product.wacs]: 'Assessments',
  [Product.ccn]: 'Camp Consonant',
  [Product.upstart]: 'Upstart',
  [Product.ayla]: 'Assessments',
  [Product.assessments]: 'Assessments',
};

export const ProductDisplayOrder = {
  [Product.smartstart]: 0,
  [Product.erp]: 1,
  [Product.ems]: 2,
  [Product.ccn]: 3,
  [Product.upstart]: 4,
  [Product.wacs]: 5,
};
